import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';
import { saveAs } from 'file-saver';

pdfMake.vfs = pdfFonts.pdfMake ? pdfFonts.pdfMake.vfs : pdfFonts;

export async function saveReportFile(blob, filename) {
  if (window.Capacitor?.isNativePlatform?.()) {
    const { Filesystem, Directory } = await import('@capacitor/filesystem');
    const base64 = await new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = () => resolve(String(reader.result).split(',')[1]);
      reader.onerror = () => reject(new Error('Não foi possível preparar o relatório para salvar.'));
      reader.readAsDataURL(blob);
    });
    await Filesystem.writeFile({ path: filename, data: base64, directory: Directory.Documents });
    alert(`Relatório salvo!\n\nArquivo: ${filename}\n\nProcure na pasta Documentos do gerenciador de arquivos.`);
  } else {
    saveAs(blob, filename);
  }
}

export async function salvarRelatorioPdf(docDefinition, filename) {
  const blob = await new Promise((resolve, reject) => {
    const stream = pdfMake.createPdf(docDefinition).getStream();
    const parts = [];
    stream.on('data', part => parts.push(part));
    stream.on('error', reject);
    stream.on('end', () => resolve(new Blob(parts, { type: 'application/pdf' })));
    stream.end();
  });
  await saveReportFile(blob, filename);
}
